const hasChildren = (children) =>
  !(
    children === null ||
    children === undefined ||
    (Array.isArray(children) && children.length === 0)
  );

const getUnusedProps = (definedProps, allProps) =>
  Object.keys(allProps).reduce((acc, prop) => {
    if (!Object.prototype.hasOwnProperty.call(definedProps, prop)) acc[prop] = allProps[prop];
    return acc;
  }, {});

export default {
  getUnusedProps,
  hasChildren,
};
